import { CheckCircle, Filter, MoreHorizCircle, Star } from "iconoir-react";
import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

import { Box, Collapse, IconButton, TablePagination } from "@mui/material";
import queryString from "query-string";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { inject, observer } from "mobx-react";
import UnreadText from "../components/common/UnreadText";
import {
    findCreater,
    findHandler,
    getNameInCapitalize,
    TextWrap,
} from "../utils/common";
import { EmptyText } from "../components/common/CellText";
import moment from "moment";
import { DATE_FORMAT_SLASH, WORK_STATUS } from "../utils/constants";
import EmptyData from "../components/image/EmptyData";
import SkeletonTable from "../components/Skeleton/SkeletonTable";
import SearchAdvance from "../modules/work/SearchAdvanceModal";
import ContentModal from "../components/dialog/ContentModal";
import HandlerModal from "../components/dialog/HandlerModal";
import WorkTable from "../modules/work/WorkTable";

const TRANG_THAI_WIDTH = 129;
const CONG_VIEC_WIDTH = 241;
const NGUOI_XU_LY_WIDTH = 145;
const NGUOI_TAO_WIDTH = 151;
const HAN_HOAN_THANH_WIDTH = 162;
const WorkPage = ({ workStore }) => {
    const { workList, workDetail, totalWork, subwork, clearSubWork } =
        workStore;
    const location = useLocation();
    const queryStringParse = queryString.parse(location.search, {
        arrayFormat: "index",
    });
    const navigate = useNavigate();

    const [filter, setFilter] = useState({
        page: 0,
        size: 10,
        title: null,
        to_date: null,
        from_date: null,
        status: null,
    });
    const [isRefreshPage, setIsRefreshPage] = useState(true);
    const [loading, setLoading] = useState(true);

    const [openSearchAdvance, setOpenSearchAdvance] = useState(false);
    const [searchString, setSearchString] = useState();

    const [openContent, setOpenContent] = useState(false);
    const [openHandler, setOpenHandler] = useState(false);
    const [workSelect, setWorkSelect] = useState({});

    const getWorkList = async (params) => {
        try {
            setLoading(true);
            await workStore.getWorkList(params);
            clearSubWork();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const params = {
            page: queryStringParse.page || filter.page,
            size: queryStringParse.size || filter.size,
            title: queryStringParse.title || filter.title,
            is_unread: queryStringParse.is_unread || filter.is_unread,
            is_important: queryStringParse.is_important || filter.is_important,
            status: queryStringParse.status || filter.status,
            to_date: queryStringParse.to_date || filter.to_date,
            from_date: queryStringParse.from_date || filter.from_date,
        };
        setFilter(params);
        setSearchString(queryStringParse.title || "");
        (async () => {
            await getWorkList(params);
            setIsRefreshPage(false);
        })();
    }, []);
    useEffect(() => {
        if (isRefreshPage) return;
        const queryStringStringify = queryString.stringify(filter, {
            skipNull: true,
        });
        navigate({ pathname: "/work", search: queryStringStringify });
        (async () => {
            try {
                await getWorkList(filter);
            } catch (err) {
                console.log(err);
            }
        })();
    }, [filter]);

    const handleQuickSearch = () => {
        setFilter({ ...filter, page: 0, title: searchString });
    };

    const handleChangeRowsPerPage = (event) => {
        setFilter({
            ...filter,
            page: 0,
            size: parseInt(event.target.value, 10),
        });
    };
    const onChangePagination = (event, pageIndex) => {
        setFilter({ ...filter, page: +pageIndex });
    };

    function createData(
        title,
        calories,
        fat,
        carbs,
        status,
        important,
        has_subwork,
        code,
        parent_id
    ) {
        return {
            title,
            calories,
            fat,
            carbs,
            status,
            important,
            has_subwork,
            code,
            parent_id,
        };
    }
    const formatData = (dataList) => {
        return dataList.map((record) =>
            createData(
                <UnreadText
                    text={record?.title}
                    isUnread={checkUnread(record)}
                    width={CONG_VIEC_WIDTH - 20}
                    icon={
                        <MoreHorizCircle
                            className="text-primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpenContent(true);
                                setWorkSelect(record);
                            }}
                        />
                    }
                />,
                <UnreadText
                    text={
                        record?.assignees &&
                        getNameInCapitalize(
                            findHandler(record?.assignees)[0].name_uppercase
                        )
                    }
                    isUnread={checkUnread(record)}
                    icon={
                        <MoreHorizCircle
                            className="text-primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpenHandler(true);
                                setWorkSelect(record);
                            }}
                        />
                    }
                    width={NGUOI_XU_LY_WIDTH - 20}
                />,
                <UnreadText
                    text={
                        record?.assignees &&
                        findCreater(record?.assignees).map((item) =>
                            getNameInCapitalize(item.name_uppercase)
                        )
                    }
                    isUnread={checkUnread(record)}
                    width={NGUOI_TAO_WIDTH - 20}
                />,
                <UnreadText
                    text={
                        record?.due_date ? (
                            moment(record?.due_date).format(DATE_FORMAT_SLASH)
                        ) : (
                            <TextWrap>
                                <EmptyText>Không rõ</EmptyText>
                            </TextWrap>
                        )
                    }
                    isUnread={checkUnread(record)}
                    width={NGUOI_TAO_WIDTH - 20}
                />,

                // record?.assignees && findCreater(record?.assignees),

                record?.status,
                record?.important,
                record?.has_subwork,
                record?.code,
                record?.parent_id
            )
        );
    };
    const checkUnread = (record) => record.is_read !== true;
    const rows = formatData(workList);
    const subworkRows = formatData(subwork);
    return (
        <MainLayout initialValue={3}>
            <div className="px-5">
                <div className="flex justify-between items-center mb-[16px]">
                    <div className="font-bold text-[28px] leading-[29px]  ">
                        Công việc
                    </div>
                    <span
                        className="w-5 cursor-pointer"
                        onClick={() => {
                            setOpenSearchAdvance(true);
                        }}
                    >
                        <Filter />
                    </span>
                </div>
                <input
                    type="text"
                    placeholder="Tìm kiếm"
                    className="bg-[#F8F8F8] mt-2 px-5 py-4 rounded-xl w-full  focus-visible:outline-none"
                    onChange={(e) => {
                        setSearchString(e.target.value);
                    }}
                    value={searchString}
                    onSubmit={handleQuickSearch}
                    onBlur={handleQuickSearch}
                    onKeyPress={(e) => {
                        if (e.key === "Enter") {
                            handleQuickSearch();
                        }
                    }}
                />
                {loading ? (
                    <SkeletonTable />
                ) : workList?.length > 0 ? (
                    <>
                        <section className="mt-5 overflow-x-auto hideScrollbar work-table">
                            <TableContainer
                                component={Paper}
                                className="w-[840px] "
                            >
                                <Table
                                    sx={{
                                        [`& .${tableCellClasses.root}`]: {
                                            borderBottom: "none",
                                        },
                                        fontSize: 14,
                                        lineHeight: 24,
                                        borderCollapse: "separate",
                                        borderSpacing: "0px 6px",
                                    }}
                                    aria-label="collapsible table"
                                >
                                    <TableHead className="bg-primary ">
                                        <TableRow>
                                            <TableCell
                                                width={TRANG_THAI_WIDTH}
                                                align="center"
                                                className="text-white font-bold w-[127px]"
                                            >
                                                Trạng thái
                                            </TableCell>
                                            <TableCell
                                                width={CONG_VIEC_WIDTH}
                                                className="font-bold text-white"
                                            >
                                                Công việc
                                            </TableCell>
                                            <TableCell
                                                width={NGUOI_XU_LY_WIDTH}
                                                className="font-bold text-white"
                                            >
                                                Người xử lý
                                            </TableCell>
                                            <TableCell
                                                width={NGUOI_TAO_WIDTH}
                                                className="font-bold text-white"
                                            >
                                                Người tạo
                                            </TableCell>
                                            <TableCell
                                                width={HAN_HOAN_THANH_WIDTH}
                                                className="font-bold text-white"
                                            >
                                                Hạn hoàn thành
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => (
                                            <WorkTable
                                                key={row.code}
                                                row={row}
                                                subwork={subworkRows}
                                            />
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </section>{" "}
                        <TablePagination
                            component="div"
                            count={totalWork}
                            page={+filter.page}
                            onPageChange={onChangePagination}
                            rowsPerPage={filter.size}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Số bản ghi"
                        />
                    </>
                ) : (
                    <EmptyData />
                )}
            </div>
            <SearchAdvance
                openSearchAdvance={openSearchAdvance}
                handleCloseSearchAdvance={() => {
                    setOpenSearchAdvance(false);
                }}
                setFilter={setFilter}
                filter={filter}
            />
            <ContentModal
                open={openContent}
                handleClose={() => {
                    setOpenContent(false);
                }}
                content={workSelect?.content}
            />
            <HandlerModal
                open={openHandler}
                handleClose={() => {
                    setOpenHandler(false);
                }}
                handler={findHandler(workSelect?.assignees || [])}
            />
        </MainLayout>
    );
};

export default inject("workStore")(observer(WorkPage));
